import Rover from '@rover/globals/Rover';

Rover.utils = Rover.utils || {};

export const getUrlParameter = function(name) {
  return (
    decodeURIComponent(
      (new RegExp(`[?|&]${name}=` + `([^&;]+?)(&|#|;|$)`).exec(window.location.search) || [
        ,
        '',
      ])[1].replace(/\+/g, '%20')
    ) || null
  );
};

Rover.utils.getUrlParameter = getUrlParameter;

Rover.utils.hasHashParam = function(name) {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    if (hash.indexOf(name) !== -1) {
      return true;
    }
  }
  return false;
};

export const appendUrlParams = (url, params) => {
  let joiner = '?';
  if (url.indexOf(joiner) !== -1) joiner = '&';

  let newUrl = url;

  if (typeof params === 'string') {
    newUrl += `${joiner}${params}`;
  } else {
    Object.keys(params).forEach(key => {
      newUrl += `${joiner}${key}=${params[key]}`;
      joiner = '&';
    });
  }

  return newUrl;
};

export const addEventParamsToUrl = (url, gtmEventParameters) => {
  let newUrl = url;
  if (gtmEventParameters) {
    for (let i = 0; i < gtmEventParameters.length; i += 1) {
      const params = gtmEventParameters[i];
      let paramsString = '';

      if (params) {
        Object.keys(params).forEach(key => {
          if (Array.isArray(params[key])) {
            const arr = params[key];
            if (arr.length) {
              arr.forEach(val => {
                paramsString += paramsString ? '&' : '';
                paramsString += `${key}[]=${val}`;
              });
            } else {
              paramsString += paramsString ? '&' : '';
              paramsString += `bepEmptyList=${key}`;
            }
          } else {
            paramsString += paramsString ? '&' : '';
            paramsString += `${key}=${params[key]}`;
          }
        });

        if (paramsString) {
          newUrl += `${newUrl.split('?')[1] ? '&' : '?'}bep=${encodeURIComponent(paramsString)}`;
        }
      }
    }
  }

  return newUrl;
};

export const redirect = url => {
  window.location = url;
};

window.isRoverURL = function(url) {
  return (
    url.indexOf('//') === -1 ||
    url.indexOf(Rover.urls.base) !== -1 ||
    url.indexOf('//localhost') !== -1 ||
    url.indexOf('//0.0.0.0') !== -1 ||
    url.indexOf('//127.0.0.1') !== -1
  );
};

export default {
  ...Rover.utils,
  redirect,
  addEventParamsToUrl,
};



// WEBPACK FOOTER //
// ../utilities/url.js